import { getSession } from '../services/storage-service';
import { getLoginBusinessId } from '../services/auth-details-service';

/**
 * The `useTxnInfo` function retrieves transaction information for a specific service type from the
 * user account object storage.
 * @returns The function `useTxnInfo` returns an object with a single property `transactionInfo`, which
 * is a function.
 */
export default function useAccountServiceHook() {
  /* The line `const userData = useSelector((state) => state?.auth?.loginUserData);` is using the
`useSelector` hook from the `react-redux` library to retrieve the `loginUserData` property from the
`auth` slice of the Redux store. */
  const businessId = getLoginBusinessId();

  /**
   * The function `transactionInfo` retrieves the object permissions for a specific service type from
   * the user account object storage.
   * @param svcType - The `svcType` parameter represents the type of service for which you want to
   * retrieve transaction information.
   * @returns The function `transactionInfo` returns the value of
   * `userAccountObjStorage?.objPermissions?.[svcType]` if `svcType` is truthy.
   */
  const accountUserServiceList = (svcType) => {
    const userAccountObjStorage = getSession(`${businessId}_biz_accocunt_user_service_list`, true)
      ?.bizAccountServiceList?.[svcType];
    if (svcType) return userAccountObjStorage;
  };

  return { accountUserServiceList };
}
